import GeneratedOrganizationServiceApi from "./generated/GeneratedOrganizationServiceApi"

class OrganizationServiceApi extends GeneratedOrganizationServiceApi {

}

export const organizationServiceApi = new OrganizationServiceApi()
